import { useCallback, useEffect, useState } from "react";
import { ServicePricingSchema, TServicePricing } from "@shared/entities";
import { firebaseApi } from "src/firebase-api";

/** Price per service level (settings/pricing), as set by an admin. */
export function useServicePricing() {
	const [pricing, setPricing] = useState<TServicePricing | null>(null);

	const load = useCallback(async () => {
		const doc = await firebaseApi.firestore.get<{ id: string } & TServicePricing>({
			collectionName: "settings",
			id: "pricing",
		});
		const parsed = ServicePricingSchema.safeParse(doc ?? {});
		setPricing(parsed.success ? parsed.data : {});
	}, []);

	useEffect(() => {
		load();
	}, [load]);

	/** Saves the prices; an empty price means "any payment settles it". */
	const save = useCallback(async (next: TServicePricing) => {
		await firebaseApi.firestore.set({
			collectionName: "settings",
			item: { id: "pricing", full: next.full ?? null, basic: next.basic ?? null },
		});
		setPricing(next);
	}, []);

	return { pricing, save };
}
